import DoneIcon from '@mui/icons-material/Done';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CoachSession } from '../../../backendsdk';
import ConfirmDialog from '../../../components/ConfirmDialog';
import useApi from '../../../hooks/api';

export interface CompleteSessionDialogProps {
    details: CoachSession;
    setAlert: CallableFunction;
    onComplete: CallableFunction;
    isUpdatingSession: boolean;
    setIsUpdatingSession: CallableFunction;
    setIsConfirmOpen: CallableFunction;
}

const CompleteSessionDialog: React.FC<CompleteSessionDialogProps> = (props: CompleteSessionDialogProps) => {
    const { details } = props;
    const { api } = useApi();
    const { t } = useTranslation();
    const toComplete = !details.completed_at;

    const updateSession = () => {
        if (details !== undefined) {
            props.setIsUpdatingSession(true);
            api.apiV1CoachSessionIdPost({
                sessionId: details.session_id,
                updateCoachSession: {
                    ...details,
                    complete: toComplete,
                },
            })
                .then((res) => {
                    props.onComplete(res.data);
                    props.setIsConfirmOpen(false);
                })
                .catch(() =>
                    props.setAlert({
                        message: toComplete
                            ? t('content.coach.errors.complete_session')
                            : t('content.coach.errors.reopen_session'),
                        type: 'error',
                        duration: 6000,
                    }),
                )
                .finally(() => props.setIsUpdatingSession(false));
        }
    };

    return (
        <ConfirmDialog
            isDialogOpen
            headerText={t(`content.coach.details.${toComplete ? 'complete' : 'reopen'}_session`)}
            headerIcon={<DoneIcon sx={{ mr: 0.5 }} />}
            bodyText={t(`content.coach.details.confirm_${toComplete ? 'complete' : 'reopen'}`)}
            buttonText={t(`content.coach.${toComplete ? 'complete' : 'reopen'}`)}
            buttonColor="secondary"
            onClose={() => props.setIsConfirmOpen(false)}
            onConfirm={() => updateSession()}
            isLoading={props.isUpdatingSession}
        />
    );
};

export default CompleteSessionDialog;
